import React, { useEffect, useState } from 'react';
import i18n from 'i18next';
import ObjectExploder from '@app/components/ObjectExploder/objectExploder.component';

interface IReceivedData {
    item: any;
    prefix: string;
}

const ObjectExploderComponent = (props: IReceivedData) => {
    const [itemParsed, setItemParsed] = useState('');
    const [propertyList, setPropertyList] = useState<any>([]);

    useEffect(() => {
        setItemParsed(tryParse(props.item));
        explode(props.item);
    }, []);

    const tryParse = (obj: any) => {
        try {
            if (typeof obj === 'string') {
                obj = JSON.parse(obj);
            }
        }
        catch (e) {
            // is string value
        }

        return obj;
    };

    const explode = (obj: any) => {
        obj = tryParse(obj);

        let props: any = [];

        if (isArray(obj)) {
            obj.forEach(function (a: any) {
                props.push(explode(a));
            });

            return props;
        }

        if (typeof obj !== 'string' && obj) {
            Object.keys(obj).forEach(function (p) {
                let prop: any = obj[p];

                props.push({ name: p, value: prop });
            });
        }
        else {
            return obj;
        }

        setPropertyList(props);
    };

    const isArray = (arr: any) => {
        return Object.prototype.toString.call(arr) === '[object Array]';
    };

    const title = (str: string) => {
        return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    };

    const getTypeNameTranslatedName = (item: string, getTitle?: number) => {
        if (item !== undefined && item !== '' && isString(item)) {
            let translated: string = i18n.t(item);

            if (translated !== item) {
                return translated;
            }

            const name = props.prefix + '_' + item.toUpperCase();

            translated = i18n.t(name);

            if (translated === name) {
                if (getTitle) {
                    return title(item);
                }

                return item;
            }

            return translated;
        }

        return '';
    };

    const isType = (args: string[]) => {
        if (args && args.length) {
            const actual: string = args[0];

            for (let i = 1; i < args.length; i++) {
                const expectedType: string = args[i];

                if (expectedType === 'array') {

                    if (isArray(actual)) {
                        return true;
                    }
                }

                if (typeof actual === expectedType) {
                    return true;
                }
            }
        }

        return false;
    };

    const isStringOrNumber = (item: string) => {
        let args: string[] = [];
        args.push(item);
        args.push('string');
        args.push('number');

        const valid: boolean = isType(args);

        return valid;
    };

    const isString = (item: string) => {
        let args: string[] = [];
        args.push(item);
        args.push('string');

        const valid: boolean = isType(args);

        return valid;
    };

    return (
        <>
            {isStringOrNumber(itemParsed) &&
                <span className='log__list--item__content'>{getTypeNameTranslatedName(itemParsed)}</span>
            }

            {!isString(itemParsed) &&
                <div className='log__list'>
                    <ul>
                        {propertyList.map((thisItem: any, index: number) => (
                            <li key={index}>
                                {thisItem.name !== undefined &&
                                    <div className='log__list--item__wrapper'>
                                    <span className='log__list--item__name'>{getTypeNameTranslatedName(thisItem.name, 1)}</span>
                                        <ObjectExploder prefix={props.prefix} item={thisItem.value} key={Math.floor(Math.random() * 1000)} />
                                    </div>
                                }
                                {isArray(thisItem) &&
                                    <div className='log__list--item__wrapper'>
                                    {thisItem.map((itemChild: any, indexChild: number) =>
                                            <span key={indexChild}>
                                                <span className='log__list--item_name'>{getTypeNameTranslatedName(itemChild.name, 1)}</span>
                                                <ObjectExploder prefix={props.prefix} item={itemChild.value} key={Math.floor(Math.random() * 1000)} />
                                            </span>
                                        )}
                                    </div>
                                }
                                {isString(thisItem) &&
                                    <div>{getTypeNameTranslatedName(thisItem)}</div>
                                }
                            </li>
                        ))}
                    </ul>
                </div>
            }
        </>
    );
};

export default ObjectExploderComponent;